import React from 'react';
import { Field } from 'redux-form';
import { string } from 'prop-types';
import { required } from 'helpers/validate';
import { renderTextField } from './customFields';

export default class ApplicationField extends React.Component {
  static propTypes = {
    componentType: string
  };

  render() {
    return (
      <Field
        name={this.props.componentType}
        component={renderTextField}
        validate={[required]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/components/packageFormFields/ApplicationField.js